export const removeDupsById = (options: any[]) => {
  return options.filter(
    (ele, ind) => ind === options.findIndex((elem) => elem.id === ele.id)
  );
};
